module.exports = __webpack_public_path__ + "b65c2ca8e6c9e92e2d7fd52e7234fa7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/deloitte_2023_chart.png
// module id = 1660
// module chunks = 0